// Domain model
export default function domain(
  domain,
  type,
  defaultIncludeVat,
  decimalSeparator,
) {
  const price = defaultIncludeVat
    ? domain.domain.price.full.total
    : domain.domain.price.full.base;

  const rebatedPrice =
    domain.domain.price.rebated &&
    (defaultIncludeVat
      ? domain.domain.price.rebated.total
      : domain.domain.price.rebated.base);

  return {
    available: domain.available,
    hasRebate:
      domain.domain.price.rebateType !== "NONE" && rebatedPrice !== null,
    rebateType: domain.domain.price.rebateType,
    hasRebateLabel:
      domain.domain.price.rebateType !== "OTHER" &&
      domain.domain.price.rebateType !== "NONE",
    isFreeWithHosting: domain.domain.price.rebateType === "FREE_WITH_HOSTING",
    domain: domain.domain.domain.prefix,
    tld: domain.domain.domain.tld,
    fullDomain: domain.domain.domain.full,
    price: price.toString().replace(".", decimalSeparator),
    rebatedPrice:
      rebatedPrice && rebatedPrice.toString().replace(".", decimalSeparator),
    type: type,
    isSuggested: type === "suggestions",

    showRebatedPrice: !/^(0\.00|0,00|0|0,-)$/.test(
      domain.domain.price.rebated && domain.domain.price.rebated.total,
    ),
  };
}

/*
  Example response for a domain:
  {
    available: true,
    rebateLabel: "",
    rebateType: "OTHER",
    rebatePriceText:
      '<span class="currency">€</span> <span class="price">7,99</span>',
    rebatePriceOnly: "7,99",
    searchTypeValue: 2,
    domain: "mycooldomain",
    domainSuffix: ".it",
    category: 0,
    priceOnly: "10,99",
    priceText:
      '<span class="currency">€</span> <span class="price">10,99</span>',
  }

*/
